import Popper from 'popper.js';
import PopupHandler from './popup-handler';

const createPopper = (...args) => new Popper(...args);

export default new PopupHandler(window, createPopper);
